exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".MedsSummaryItem{margin:0;width:100%;height:100%}.MedsSummaryItem-Name{margin-top:10px;font-size:14px;color:var(--text-primary)}", ""]);

// exports
